module.exports = __webpack_public_path__ + "MetaWebPro-Bold.d347589c4fd824bf03c7.woff";


//////////////////
// WEBPACK FOOTER
// /var/data/workspace/hess/hess_smart_city_web/src/assets/fonts/MetaWebPro-Bold.woff
// module id = ../../../../../src/assets/fonts/MetaWebPro-Bold.woff
// module chunks = styles